import { getDiffDateServerMilli } from '@/services/utils';
import * as moment from 'moment';

export function dateFormat(
  date?: string,
  type: 'BR' | 'US' | 'UNIX' | 'ISO' | 'ISO-DATE' | 'BR-TIME' | 'DAY' | string = 'BR',
  inputFormat?: string,
  canReturnNull: boolean = false,
): string {
  let format;
  switch (type) {
    case 'BR':
      format = 'DD/MM/YYYY';
      break;
    case 'BR-TIME':
      format = 'DD/MM/YYYY HH:mm';
      break;
    case 'US':
      format = 'YYYY-MM-DD';
      break;
    case 'UNIX':
      format = 'X';
      break;
    case 'ISO':
      format = 'YYYY-MM-DDTHH:mm:ss.SSSZ';
      break;
    case 'ISO-DATE':
      format = 'YYYY-MM-DD';
      break;
    default:
      format = type
  }


  const dateIsValid = moment(date, inputFormat).isValid();

  if (!date || !dateIsValid) {
    if (!!canReturnNull) {
      return '';
    }

    return moment().format(format);
  }

  return moment(date, inputFormat).locale('pt-br').format(format);
}

export function getServerISODateTime() {
  var date = getDataAjustadaServer();
  date = new Date(
    date.getTime() - date.getTimezoneOffset() * 60000,
  );
  let dateS = date.toISOString();
  return dateS;
}

export function getServerISODate() {
  try {
    let date = getServerISODateTime();
    date = date.substring(0, 10);
    return date;
  } catch(e) {
    console.error(e);
    return new Date().toISOString().substring(0, 10);
  }
}

export function getDataAjustadaServer(): Date {
  let time = Number(new Date().getTime()) + Number(getDiffDateServerMilli());
  return new Date(time);
}
